


























































































































































































































































































import { CancelTokenSource } from 'axios';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import Card from '@/components/UI/Card.vue';
import Toast from '@/mixins/toast';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';

import AdminProfileModal from './AdminProfileModal.vue';
import AuditorCardModal from './AuditorCardModal.vue';
import AuditorFormModal from './AuditorFormModal.vue';
import AuditorPasswordResetModal from './AuditorPasswordResetModal.vue';
import MmHintedButton from '../../components/MmHintedButton.vue';
import MmStates from '../../components/MmStates.vue';
import MmTable from '../../components/MmTable.vue';
import {
	activateAuditor,
	deactivateAuditor,
	fetchAuditors,
	resetAuditorPassword,
} from '../../api/auditors';
import { createCancelSource, readMmError } from '../../api/mmHttp';
import {
	buildPageQuery,
	createPaginationState,
	createSortingState,
	MmPaginationState,
	MmSortingState,
	resolvePagerTotal,
} from '../../api/pagination';
import { formatDiagnostics, isCanceled, MmError, toMmError } from '../../core/errors';
import { formatDate, orDash } from '../../core/format';
import { getSessionStore, retryMobileSession } from '../../core/session';
import { MmAuditor } from '../../types/domain';
import { MmErrorCode } from '../../types/enums';

const KEY = 'priceMonitoring.mobileMonitoring.auditors.';

/** Тип описан структурно: импортировать его из .vue TypeScript не умеет */
interface MmTableChange {
	pagination: MmPaginationState;
	sorter: MmSortingState;
	filters: { [key: string]: any };
}

@Component({
	components: {
		AdminProfileModal,
		AuditorCardModal,
		AuditorFormModal,
		AuditorPasswordResetModal,
		Card,
		ColumnTitleContent,
		MmHintedButton,
		MmStates,
		MmTable,
	},
})
export default class AuditorsSection extends Mixins(Toast) {
	@Prop({ default: null }) readonly tradingId!: number | null;

	/** ant-design-vue 1.7.8 не размонтирует открытую вкладку, поэтому запросы идут только при isActive */
	@Prop({ default: false }) readonly isActive!: boolean;

	/** Проп объявлен, хотя не используется: иначе он осел бы в $attrs и уехал атрибутом в DOM */
	@Prop({ default: null }) readonly tradingName!: string | null;

	auditors: MmAuditor[] = [];

	isLoading: boolean = false;

	loadError: MmError | null = null;

	pagination: MmPaginationState = createPaginationState();

	sorting: MmSortingState = createSortingState();

	searchText: string = '';

	appliedSearch: string = '';

	isFormVisible: boolean = false;

	/** `null` — режим создания; объект — режим правки. */
	editingAuditor: MmAuditor | null = null;

	adminProfileVisible: boolean = false;

	cardVisible: boolean = false;

	cardAuditor: MmAuditor | null = null;

	passwordVisible: boolean = false;

	passwordAuditor: MmAuditor | null = null;

	passwordValue: string | null = null;

	rowBusyId: number | string | null = null;

	/** Ссылку держим полем: иначе наблюдатель не увидит изменения session.readyTick */
	session = getSessionStore();

	/** Флаг не сбрасываем: иначе страница без createdAt убирала бы колонку, а следующая возвращала */
	hasCreatedAt: boolean = false;

	private hasLoadedOnce: boolean = false;

	private isReloadPending: boolean = false;

	/** В axios 0.18 нет AbortController — только CancelToken */
	private cancelSource: CancelTokenSource | null = null;

	get createButtonText(): string {
		return this.$t(KEY + 'createButton') as string;
	}

	get editButtonText(): string {
		return this.$t(KEY + 'editButton') as string;
	}

	get resetSearchText(): string {
		return this.$t(KEY + 'resetSearch') as string;
	}

	get searchPlaceholderText(): string {
		return this.$t(KEY + 'searchPlaceholder') as string;
	}

	get countLabel(): string {
		return this.$t(KEY + 'countLabel', { count: this.pagination.total }) as string;
	}

	get createDisabledReason(): string {
		return this.$t(KEY + 'createDisabledNoNetwork') as string;
	}

	get isCreateDisabled(): boolean {
		return this.tradingId === null;
	}

	get profileButtonText(): string {
		return this.$t(KEY + 'profileButton') as string;
	}

	get cardButtonText(): string {
		return this.$t(KEY + 'cardButton') as string;
	}

	get resetPasswordButtonText(): string {
		return this.$t(KEY + 'resetPasswordButton') as string;
	}

	get resetPasswordWarningText(): string {
		return this.$t(KEY + 'resetPasswordWarning') as string;
	}

	get deactivateButtonText(): string {
		return this.$t(KEY + 'deactivateButton') as string;
	}

	get deactivateWarningText(): string {
		return this.$t(KEY + 'deactivateWarning') as string;
	}

	get activateButtonText(): string {
		return this.$t(KEY + 'activateButton') as string;
	}

	get activateHintText(): string {
		return this.$t(KEY + 'activateHint') as string;
	}

	get confirmOkText(): string {
		return this.$t('shared.actions.ok') as string;
	}

	get confirmCancelText(): string {
		return this.$t('shared.actions.cancel') as string;
	}

	/** Окно подтверждения ant рисуется в body, куда scoped-стиль не достаёт: ширину задаём тут */
	get confirmOverlayStyle(): { [key: string]: string } {
		return { maxWidth: '320px' };
	}

	get rowBusyReason(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.loading') as string;
	}

	/** Сортировка только серверная; у e-mail sorter снят — бэкенд по нему не сортирует */
	get columns(): any[] {
		const columns: any[] = [
			{
				key: 'fullName',
				dataIndex: 'fullName',
				slots: { title: 'fullNameColumnTitle' },
				slotColumnTitleData: { text: this.$t(KEY + 'colFullName') as string },
				width: 260,
				sorter: true,
			},
			{
				key: 'login',
				dataIndex: 'login',
				slots: { title: 'loginColumnTitle' },
				slotColumnTitleData: { text: this.$t(KEY + 'colLogin') as string },
				width: 200,
				sorter: true,
			},
			{
				key: 'email',
				dataIndex: 'email',
				slots: { title: 'emailColumnTitle' },
				slotColumnTitleData: { text: this.$t(KEY + 'colEmail') as string },
				width: 240,
				scopedSlots: { customRender: 'email' },
			},
		];

		if (this.hasCreatedAt) {
			columns.push({
				key: 'createdAt',
				dataIndex: 'createdAt',
				slots: { title: 'createdAtColumnTitle' },
				slotColumnTitleData: { text: this.$t(KEY + 'colCreatedAt') as string },
				width: 160,
				sorter: true,
				scopedSlots: { customRender: 'createdAt' },
			});
		}

		/* Ширина жёсткая: одна колонка с ellipsis переводит таблицу ant в фиксированную раскладку */
		columns.push({
			key: 'actions',
			title: this.$t(KEY + 'colActions'),
			width: 170,
			scopedSlots: { customRender: 'actions' },
		});

		return columns;
	}

	get isInitialLoading(): boolean {
		return this.isLoading && !this.hasLoadedOnce;
	}

	get hasLoadError(): boolean {
		return this.loadError !== null;
	}

	get emptyState(): string {
		if (!this.hasLoadError) {
			return 'empty';
		}

		if (this.loadError !== null && this.loadError.code === MmErrorCode.FORBIDDEN) {
			return 'forbidden';
		}

		/** UNAUTHORIZED сюда не добавлять: он лечится повторным обменом сессии, а не соединением */
		if (
			this.loadError !== null
			&& (
				this.loadError.code === MmErrorCode.SERVER
				|| this.loadError.code === MmErrorCode.NETWORK
				|| this.loadError.code === MmErrorCode.TIMEOUT
			)
		) {
			return 'unavailable';
		}

		return 'error';
	}

	get isLoadErrorRetryable(): boolean {
		return this.loadError !== null && this.loadError.retryable;
	}

	get emptyTitle(): string {
		if (this.emptyState === 'forbidden' || this.emptyState === 'unavailable') {
			return '';
		}

		if (this.hasLoadError) {
			return this.$t(KEY + 'errorTitle') as string;
		}

		return this.$t(KEY + (this.appliedSearch === '' ? 'emptyTitle' : 'emptyFiltered')) as string;
	}

	get emptyText(): string {
		if (this.emptyState === 'forbidden' || this.emptyState === 'unavailable') {
			return '';
		}

		if (this.hasLoadError) {
			return this.$t(KEY + 'errorText') as string;
		}

		return '';
	}

	get showEmptyCta(): boolean {
		return !this.hasLoadError && this.appliedSearch === '';
	}

	get showResetCta(): boolean {
		return !this.hasLoadError && this.appliedSearch !== '';
	}

	get errorDiagnostics(): string {
		return this.loadError === null ? '' : formatDiagnostics(this.loadError.diagnostics);
	}

	get loadErrorText(): string {
		return this.loadError !== null && this.loadError.message
			? String(this.loadError.message).trim()
			: '';
	}

	/* Форматирование только через слоты: customRender в описании колонки ant 1.7.8 ячейку не меняет */

	isBlank(value: any): boolean {
		return value === null || value === undefined || String(value).trim() === '';
	}

	formatText(value: string | null): string {
		return orDash(value);
	}

	formatCreatedAt(value: string | null): string {
		return formatDate(value);
	}

	mounted(): void {
		if (this.tradingId !== null) {
			this.loadAuditors();
		}
	}

	beforeDestroy(): void {
		this.cancelPendingRequest();
	}

	@Watch('session.readyTick')
	onSessionReady(): void {
		if (this.tradingId === null) {
			return;
		}

		if (!this.isActive) {
			this.isReloadPending = true;

			return;
		}

		this.loadAuditors();
	}

	@Watch('isActive')
	onIsActiveChanged(next: boolean): void {
		if (next && this.isReloadPending) {
			this.isReloadPending = false;
			this.loadAuditors();
		}
	}

	get searchPending(): boolean {
		const draft = this.searchText === null || this.searchText === undefined
			? ''
			: String(this.searchText).trim();

		return draft !== this.appliedSearch;
	}

	handleApplySearch(): void {
		if (this.isLoading) {
			return;
		}

		const next = this.searchText === null || this.searchText === undefined
			? ''
			: String(this.searchText).trim();

		if (next === this.appliedSearch) {
			this.loadAuditors();

			return;
		}

		this.appliedSearch = next;
		this.pagination = {
			current: 1,
			pageSize: this.pagination.pageSize,
			total: this.pagination.total,
		};

		this.loadAuditors();
	}

	handleResetSearch(): void {
		this.searchText = '';
		this.appliedSearch = '';
		this.pagination = {
			current: 1,
			pageSize: this.pagination.pageSize,
			total: this.pagination.total,
		};
		this.loadAuditors();
	}

	/** Направление сортировки приходит уже приведённым, переводить его здесь второй раз нельзя */
	handleTableChange(event: MmTableChange): void {
		this.pagination = {
			current: event.pagination.current,
			pageSize: event.pagination.pageSize,
			total: this.pagination.total,
		};
		this.sorting = { field: event.sorter.field, order: event.sorter.order };

		this.loadAuditors();
	}

	reload(): void {
		this.loadAuditors();
	}

	loadAuditors(): void {
		if (this.tradingId === null) {
			this.auditors = [];
			this.pagination = { current: 1, pageSize: this.pagination.pageSize, total: 0 };
			this.isLoading = false;
			this.loadError = null;

			return;
		}

		this.cancelPendingRequest();

		const source = createCancelSource();

		this.cancelSource = source;
		this.isLoading = true;
		this.loadError = null;

		const query = { q: this.appliedSearch === '' ? null : this.appliedSearch };
		const pageParams = buildPageQuery(this.pagination, this.sorting);

		fetchAuditors(this.tradingId, query, pageParams, { cancelToken: source.token })
			.then((page) => {
				if (this.cancelSource !== source) {
					return;
				}

				this.cancelSource = null;
				this.auditors = page.content;
				this.pagination = {
					current: this.pagination.current,
					pageSize: this.pagination.pageSize,
					total: resolvePagerTotal(page, this.pagination),
				};
				this.rememberCreatedAtSupport(page.content);
				this.isLoading = false;
				this.hasLoadedOnce = true;
			})
			.catch((error) => {
				/** Отменённый запрос не ошибка, и loading не гасим: следом уже летит новый */
				if (isCanceled(error)) {
					return;
				}

				if (this.cancelSource !== source) {
					return;
				}

				this.cancelSource = null;
				this.isLoading = false;
				this.hasLoadedOnce = true;
				this.auditors = [];

				const mmError = toMmError(error, 'auditors/list');

				this.loadError = mmError;

				if (mmError.code === MmErrorCode.UNAUTHORIZED) {
					retryMobileSession().catch(() => undefined);
				}
			});
	}

	private cancelPendingRequest(): void {
		if (this.cancelSource !== null) {
			this.cancelSource.cancel();
			this.cancelSource = null;
		}
	}

	private rememberCreatedAtSupport(rows: MmAuditor[]): void {
		if (this.hasCreatedAt) {
			return;
		}

		for (let i = 0; i < rows.length; i += 1) {
			if (rows[i] && rows[i].createdAt !== null && rows[i].createdAt !== undefined) {
				this.hasCreatedAt = true;

				return;
			}
		}
	}

	openCreateForm(): void {
		this.editingAuditor = null;
		this.isFormVisible = true;
	}

	openEditForm(auditor: MmAuditor): void {
		this.editingAuditor = auditor;
		this.isFormVisible = true;
	}

	closeForm(): void {
		this.isFormVisible = false;
	}

	handleSaved(): void {
		this.isFormVisible = false;
		this.loadAuditors();
	}

	openAdminProfile(): void {
		this.adminProfileVisible = true;
	}

	closeAdminProfile(): void {
		this.adminProfileVisible = false;
	}

	/* Идентификаторы сравниваем только через String(): id бывает и числом, и строкой UUID */

	isRowBusy(auditor: MmAuditor): boolean {
		if (auditor === null || auditor === undefined || this.rowBusyId === null) {
			return false;
		}

		return String(auditor.id) === String(this.rowBusyId);
	}

	isAuditorDeactivated(auditor: MmAuditor): boolean {
		return auditor !== null && auditor !== undefined && auditor.status === 'deactivated';
	}

	auditorName(auditor: MmAuditor): string {
		if (auditor === null || auditor === undefined) {
			return '';
		}

		if (auditor.fullName !== null && auditor.fullName !== undefined && String(auditor.fullName).trim() !== '') {
			return String(auditor.fullName);
		}

		return auditor.login === null || auditor.login === undefined ? '' : String(auditor.login);
	}

	resetPasswordConfirmText(auditor: MmAuditor): string {
		return this.$t(KEY + 'resetPasswordConfirm', { name: this.auditorName(auditor) }) as string;
	}

	deactivateConfirmText(auditor: MmAuditor): string {
		return this.$t(KEY + 'deactivateConfirm', { name: this.auditorName(auditor) }) as string;
	}

	activateConfirmText(auditor: MmAuditor): string {
		return this.$t(KEY + 'activateConfirm', { name: this.auditorName(auditor) }) as string;
	}

	openAuditorCard(auditor: MmAuditor): void {
		this.cardAuditor = auditor;
		this.cardVisible = true;
	}

	closeAuditorCard(): void {
		this.cardVisible = false;
	}

	onCardRefreshed(fresh: MmAuditor): void {
		if (fresh === null || fresh === undefined) {
			return;
		}

		for (let i = 0; i < this.auditors.length; i += 1) {
			if (String(this.auditors[i].id) === String(fresh.id)) {
				this.auditors.splice(i, 1, fresh);

				return;
			}
		}
	}

	/** Свой пароль не передаём — на пустом значении сервер генерирует его сам */
	handleResetPassword(auditor: MmAuditor): void {
		if (this.isRowBusy(auditor)) {
			return;
		}

		this.rowBusyId = auditor.id;

		resetAuditorPassword(auditor.id)
			.then((response) => {
				this.rowBusyId = null;

				const reset = response.data;

				this.passwordValue = reset === null || reset === undefined ? null : reset.tempPassword;
				this.passwordAuditor = auditor;
				this.passwordVisible = true;
			})
			.catch((error) => {
				this.rowBusyId = null;
				this.reportRowFailure(error, 'auditors/resetPassword', 'resetPasswordError');
			});
	}

	closePasswordReset(): void {
		this.passwordVisible = false;
		this.passwordValue = null;
		this.passwordAuditor = null;
	}

	/* Список перечитываем по ответу сервера: a-popconfirm не дожидается промиса из @confirm */

	handleDeactivate(auditor: MmAuditor): void {
		if (this.isRowBusy(auditor)) {
			return;
		}

		this.rowBusyId = auditor.id;

		deactivateAuditor(auditor.id)
			.then(() => {
				this.rowBusyId = null;
				this.showInfo(this.$t(KEY + 'deactivatedToast') as string);
				this.loadAuditors();
			})
			.catch((error) => {
				this.rowBusyId = null;
				this.reportRowFailure(error, 'auditors/deactivate', 'deactivateError');
			});
	}

	handleActivate(auditor: MmAuditor): void {
		if (this.isRowBusy(auditor)) {
			return;
		}

		this.rowBusyId = auditor.id;

		activateAuditor(auditor.id)
			.then(() => {
				this.rowBusyId = null;
				this.showInfo(this.$t(KEY + 'activatedToast') as string);
				this.loadAuditors();
			})
			.catch((error) => {
				this.rowBusyId = null;
				this.reportRowFailure(error, 'auditors/activate', 'activateError');
			});
	}

	/** Разбираем по коду и статусу, а не по тексту сообщения; перечитыванием завершается только 404 */
	private reportRowFailure(error: any, section: string, fallbackKey: string): void {
		const mmError = readMmError(error, section);

		if (mmError.code === MmErrorCode.NOT_FOUND || mmError.status === 404) {
			this.showError(this.$t(KEY + 'errAuditorNotFound') as string);
			this.loadAuditors();

			return;
		}

		if (mmError.code === MmErrorCode.UNAUTHORIZED) {
			retryMobileSession().catch(() => undefined);
		}

		this.showError(this.$t(KEY + fallbackKey) as string);
	}
}
